import { GA_MEASUREMENT_ID } from '@kinderlabs-pos/shared-const';

/**
 * web 렌더러에서 gtag.js 로 직접 GA4 이벤트를 전송한다.
 *
 * POS 프로덕션 렌더러는 file:// 오리진이라 쿠키 저장이 안 되므로
 * - client_storage: 'none' 으로 쿠키 사용을 끄고
 * - client_id 를 기기 단위로 직접 고정하며
 * - page_location 을 보정해 file:// 경로가 리포트에 남지 않게 한다.
 *
 * 측정 ID 미주입 시 조용히 no-op 한다.
 */
type GtagWindow = Window & {
	gtag?: (...args: any[]) => void;
	dataLayer?: any[];
};

let initialized = false;

const ensureInit = (clientId?: string): boolean => {
	if (!GA_MEASUREMENT_ID) return false;
	if (typeof window === 'undefined' || typeof document === 'undefined') return false;

	const w = window as GtagWindow;
	if (initialized) return true;
	initialized = true;

	const script = document.createElement('script');
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
	document.head.appendChild(script);

	w.dataLayer = w.dataLayer || [];
	w.gtag = function gtag() {
		// eslint-disable-next-line prefer-rest-params
		w.dataLayer!.push(arguments);
	};
	w.gtag('js', new Date());
	w.gtag('config', GA_MEASUREMENT_ID, {
		client_storage: 'none',
		send_page_view: false,
		page_location: 'app://pos-main',
		...(clientId ? { client_id: clientId } : {}),
	});

	return true;
};

export const sendGAEvent = (
	eventName: string,
	params: Record<string, string | number>,
	opts?: { clientId?: string }
): void => {
	if (!ensureInit(opts?.clientId)) return;
	(window as GtagWindow).gtag?.('event', eventName, params);
};
